import config from 'config';
import { getLocalAssetUrl } from 'core/utilities';
import { Image } from 'ui/components/primitives';

import { InfoComponents } from './components.styles';

const logoGB = getLocalAssetUrl('/images/logo-gb.png');

export const Info = () => {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <InfoComponents.Component>
      <InfoComponents.InfoTexts>
        <InfoComponents.Auxiliar>
          INTERBELLE COMERCIO DE PRODUTOS DE BELEZA LTDA - CNPJ: 11.137.051/0002-67 Rodovia Regis
          Bitencourt - S/N - KM437+700M/Doca 22 - CEP: 11900-000 - Ribeirão Vermelho - Registro -
          SP.
        </InfoComponents.Auxiliar>
        <InfoComponents.Auxiliar>
          © {year} {config.app.name}. Todos os direitos reservados.
        </InfoComponents.Auxiliar>
      </InfoComponents.InfoTexts>
      <InfoComponents.LogoWrapper>
        <Image src={logoGB} alt="Uma marca Grupo Boticário" />
      </InfoComponents.LogoWrapper>
    </InfoComponents.Component>
  );
};
